export default {
  STUDY_PROGRAM_CODE: 'studyProgramCode',
  CYCLE_CHILDREN: 'cycleChildren'
};